import { createFileRoute } from "@tanstack/react-router";

import { LoginAttemptsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/login-attempts")({
  component: LoginAttemptsPage,
});
